import { useDrag } from 'react-dnd';

import './styles.css';

export default function FallingBlock({
  id,
  accountItemId,
  name,
  answers,
  order,
  parents,
  description,
  startTime,
  accuracyCoefficient,
  left,
  right,
  y,
  onMouseEnter,
  onMouseLeave,
  additionalContent,
  onMouseDown,
  isDraggable = true,
}) {
  // Deps array is required — without it react-dnd captures the spec
  // on first render and never updates. That would freeze the drag
  // `item` payload against stale prop values.
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'block',
    item: { id, accountItemId, name, answers, order, parents, description, startTime, accuracyCoefficient },
    canDrag: isDraggable,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [id, accountItemId, name, order, description, startTime, isDraggable, parents, answers, accuracyCoefficient]);
  
  const leftValue = left === 'auto' ? left : left + 'px';
  const rightValue = right === 'auto' ? right : right + 'px';

  return (
    <div
      className="falling-block-container"
      ref={drag}
      style={{
        opacity: isDragging ? 0 : 1,
        left: leftValue,
        right: rightValue,
        top: `${y}px`,
      }}
    >
      <div
        className="brick"
        onMouseEnter={onMouseEnter ? () => onMouseEnter(description) : undefined}
        onMouseLeave={onMouseLeave ? onMouseLeave : undefined}
        onMouseDown={onMouseDown ? onMouseDown : undefined}
      >
        {name}
      </div>
      {
        additionalContent &&
          additionalContent
      }
    </div>
  );
};